import React, { cloneElement } from "react"
import { css } from "emotion"
import {
	useTooltip,
	TooltipPopup,
	TooltipParams,
	Position,
} from "@reach/tooltip"
import { useTransition, animated, config } from "react-spring"

let AnimatedTooltipPopup = animated(TooltipPopup)

type PositionType = "absolute" | "fixed"

function createPosition(type: PositionType): Position {
	return (targetRect, popoverRect) => {
		if (!targetRect || !popoverRect) return {}

		let top: number
		let left: number | undefined = undefined
		let right: number | undefined = undefined

		let topOffset = type === "fixed" ? 0 : window.scrollY

		if (targetRect.top < popoverRect.height + 20) {
			top = topOffset + targetRect.bottom + 10
		} else {
			top = topOffset + targetRect.top - popoverRect.height - 10
		}

		let popoverOffset =
			Math.round(targetRect.width / 2) - Math.round(popoverRect.width / 2)

		if (targetRect.left < -popoverOffset + 10) {
			left = 10
		} else if (window.innerWidth - targetRect.right < -popoverOffset + 10) {
			right = 10
		} else {
			left = targetRect.left + popoverOffset
		}

		return { position: type, top, left, right }
	}
}

let absolutePosition = createPosition("absolute")
let fixedPosition = createPosition("fixed")

type Item = TooltipParams | false

export interface TooltipProps {
	position?: PositionType
	label: string
	children: React.ReactElement
}

export default function Tooltip(props: TooltipProps) {
	let [trigger, tooltip, isVisible] = useTooltip()

	let item: Item = isVisible ? tooltip : false

	let transitions = useTransition(item, null, {
		from: { opacity: 0 },
		enter: { opacity: 1 },
		leave: { opacity: 0 },
		config: config.stiff,
	})

	return (
		<React.Fragment>
			{cloneElement(props.children, trigger)}
			{transitions.map((transition) => {
				let tooltip = transition.item

				if (!tooltip) {
					return null
				}

				return (
					<AnimatedTooltipPopup
						key={transition.key}
						{...tooltip}
						label={props.label}
						style={transition.props}
						position={
							props.position === "fixed" ? fixedPosition : absolutePosition
						}
						className={css`
							z-index: 1000002;
							padding: 0.5em 1em;
							background: black;
							color: white;
							border: none;
							border-radius: 3px;
							white-space: nowrap;
							pointer-events: none;
							font-size: 85%;
						`}
					/>
				)
			})}
		</React.Fragment>
	)
}
